module.exports = __webpack_public_path__ + "images/stickers/pete-shipped.6d36e50160369eae028e.png";